$(function(){

    var _animIndex={},_animStorage={};
    
    
    $.fn.summerGame=function(options,timeHandler){
        var th=$(this);
        var settings=th.data("summerGame");
        var animIndex;
        
        function removeAnim(){
            _animStorage[animIndex].obj_anim.clear();
            delete _animIndex[animIndex];
            delete _animStorage[animIndex];
            th.data("summerGame",false);
        }
        function drawScene(){
            
            if(typeof _animStorage[animIndex]!=="undefined"){
                
                timeHandler.set(animIndexArr.handler,function(){
//                    var tt=new Date().getTime();
                    if(_animStorage[animIndex].obj_anim.was_started){
                        _animStorage[animIndex].obj_anim.draw(ctx);
                    }
//                    $.qLog(((new Date().getTime())-tt)+" ");
                },settings.period,function(){
                    removeAnim();
                });
                
            }
            return true;
        }
        var methods={
            start:function(){
                _animStorage[animIndex].obj_anim.start();
            },
            move:function(rounds){
                _animStorage[animIndex].obj_anim.setNextMove(rounds);
            },
            stop:function(){
                timeHandler.clear(_animIndex[animIndex].handler);
            },
            takeAnimIndex:function(){
                return animIndex;
            },
            clickCrab:function(pos){
                return _animStorage[animIndex].obj_anim.clickCrab(pos);
            },
            getCrab:function(crab_id){
               return _animStorage[animIndex].obj_anim.getCrab(crab_id); 
            },
            takeGameState:function(){
                return _animStorage[animIndex].obj_anim.takeGameState();
            },
            runCrabs:function(){
                _animStorage[animIndex].obj_anim.runCrabs();
            }, 
            markCrab:function(pos){
                return _animStorage[animIndex].obj_anim.markCrab(pos);
            }
            
        };
        var zTransConf={
            percent_range:[70,100],
            margin_range:[0,300],
            margin_range_v:[0,150],
            margin_x:-200,
            margin_y:-100
        };
        function zTransformInvert(pos){
            var a,b,margin_range;
            
            margin_range=zTransConf.margin_range_v;
            b=(margin_range[1]-margin_range[0])/settings.conf_field.height;
            a=zTransConf.margin_y+margin_range[0]-b*settings.conf_field.top;
            var pos_y=Math.round((pos[1]+a)/(1-b));
            
            
            
            margin_range=zTransConf.margin_range;
            b=(margin_range[1]-margin_range[0])/settings.conf_field.height;
            a=zTransConf.margin_x+margin_range[0]-b*settings.conf_field.top;
            
            var pos_x=Math.round(pos[0]+a+b*pos_y);
            
            
            
            return [pos_x,pos_y];
            
            
        }
        function zTransform(pos){
            var percent_range=zTransConf.percent_range;
            var percent_size=100;
            percent_size=percent_range[0]+(percent_range[1]-percent_range[0])*(pos[1]-settings.conf_field.top)/settings.conf_field.height;
            
            var margin_range=zTransConf.margin_range;
            var margin=zTransConf.margin_x+margin_range[0]+(margin_range[1]-margin_range[0])*(pos[1]-settings.conf_field.top)/settings.conf_field.height;
//            margin+=zTransConf.margin_x;

            var margin_range_v=zTransConf.margin_range_v;
            var margin_v=zTransConf.margin_y+margin_range_v[0]+(margin_range_v[1]-margin_range_v[0])*(pos[1]-settings.conf_field.top)/settings.conf_field.height;
//            margin_v+=zTransConf.margin_y;
            
            pos[0]=Math.round(pos[0]-margin);
            pos[1]=Math.round(pos[1]-margin_v);
            pos[2]=percent_size;    
            
            return pos;
        }
        function crabObj(pos){
            this.pos=copyArray(pos);
            this.pos_start=copyArray(pos);
            this.conf_all={
                "in":{clips:36,loop:0},
                "out":{clips:27,loop:0},
                "whistle":{clips:24,loop:1},
                "wait":{clips:11,loop:1},
                "move":{clips:14,loop:1}
            };
            this.conf={width:170,height:191};
            this.selector={width:200,height:109,margin:[0,53],clips:6,name:"crab_down"};
            this.gift={
                name:"","opacity":100,"have":0,marked:0,
                opacity_conf:{
                    "in":{"step_arr":[0,5],"mode":"hide"}
                }
            };
            this.img_all={};
            this.step_arr=[];
            this.state="wait";
            this.step=0;
            this.step_max=0;
            this.anim_step=0;
            this.step_all=0;
            this.decision_lock=0;
            this.pos_id;
            this.onEndArr=[];
            
            this.crab_speed=20;
            
            this.smObj;
            this.smArr=[];
            
            this.in_game=1;
            this.marked=0;
        }
        crabObj.prototype={
            init:function(){
            },
            isHit:function(pos){
                var ranges=[
                    [this.pos[0]-this.conf.width/2,this.pos[0]+this.conf.width/2],
                    [this.pos[1]-this.conf.height/2,this.pos[1]+this.conf.height/2]
                ];
                var margin=[10,10];
                ranges[0][0]+=margin[0];
                ranges[0][1]-=margin[0];
                ranges[1][0]+=margin[1];
                ranges[1][1]-=margin[1];
                
                if(pos[0]>ranges[0][0] && pos[0]<ranges[0][1] &&
                   pos[1]>ranges[1][0] && pos[1]<ranges[1][1]     
                ){
                    return true;
                }
                return false;
            },
            takeState:function(){
                return this.state;
            },
            giveGift:function(gift_name){
                this.gift.have=1;
                this.gift.name=gift_name;
            },
            haveGift:function(){
                if(this.gift.have){
                    return 1;
                }
                return 0;
            },
            canMove:function(){
                if(this.state!="move"){
                    
                }
            },
            setMove:function(pos_arr,step,pos_id,zInvert,onMoveEnd){
                var i,distance_sum=0,distance_arr=[],distance;
                if(zInvert){
                    for(i in pos_arr){
                        pos_arr[i]=zTransformInvert(pos_arr[i]);
                    }
                }
                
                this.pos_start=copyArray(this.pos);
                pos_arr.unshift(copyArray(this.pos_start));
                
                for(i=0;i<pos_arr.length-1;i++){
                    distance=lengthVector(minusVector(pos_arr[i],pos_arr[i+1]));
                    distance_sum+=distance;
                    distance_arr.push(distance)
                }
                if(step==0){
                    step=Math.ceil(distance/this.crab_speed);
                }
                this.step_arr=[],distance=0;
                for(i in distance_arr){
                    distance+=distance_arr[i];
                    this.step_arr.push(distance/distance_sum*step);
                }
                
                this.pos_id=pos_id;
//              crab debug                
//                if(step==0 && typeof onMoveEnd!="undefined"){
//                     $.mypost('/ajax',{page:"timetest",tr:1});
//                }
                this.step_max=Math.max(1,step);
                this.step=0;
                this.anim_step=0;
                this.state="move";
                
                this.smObj=new Smooth(pos_arr);
                if(typeof onMoveEnd!="undefined"){
                    this.onEndArr.push(onMoveEnd);
                }
                
                return step;
            },
            setState:function(state,onEnd){
                this.anim_step=0;
                this.step_max=0;
                this.step=0;
                this.state=state;
                if(typeof onEnd!="undefined"){
                    this.step_max=this.conf_all[this.state].clips;
                    this.onEndArr.push(onEnd);
                }
                if(state=="in"){
                    _mySound.playSound("crab_in");
                }
            },
            setGiftOpacity:function(){
                if(typeof this.gift.opacity_conf[this.state]=="undefined"){
                    return false;
                }
                var conf=this.gift.opacity_conf[this.state];
                if(this.anim_step<conf.step_arr[0]){
                    return false;
                }
                if(this.anim_step>conf.step_arr[1]){
                    return false;
                }
                var percent=(this.anim_step-conf.step_arr[0])/(conf.step_arr[1]-conf.step_arr[0]);
               
                if(conf.mode=="hide"){
                    this.gift.opacity=Math.round(100-100*percent);
                }
                else{
                    this.gift.opacity=Math.round(100*percent);
                }
            },
            move:function(){
                this.step++;
                this.anim_step++;
                this.step_all++;
                var i;
                if(this.state=="move"){
                    var part=0,val_cur,val_prev=0;
                    for(i=0;i<this.step_arr.length;i++){
                        val_cur=this.step_arr[i];
                        if(val_cur<this.step){
                            part+=1;
                        }
                        else{
                            part+=(this.step-val_prev)/(val_cur-val_prev);
                            break;
                        }
                        
                        val_prev=val_cur;
                    }
                    this.pos=this.smObj(part);
                    
                }
                if(this.state=="in" || this.state=="out"){
                    this.setGiftOpacity();
                }
                if(this.state=="out" && (this.step==3 || this.step==13)){
                    _mySound.playSound("crab_out");
                }
                if(this.state=="whistle" && this.step==12){
                    _mySound.playSound("crab_whistle");
                }
                if(this.step_max && this.step>=this.step_max){
                    
                    if(this.state=="move"){
//                        this.setState("in");
                        this.setState("wait");
                        
                    }
                    if(this.onEndArr.length>0){
                        var fun=this.onEndArr.shift();
                        fun();
                    }
                    
//                    if(this.state=="in"){
//                        this.setState("shaking");
//                    }
                }
                return {pos:this.pos};
            },
            returnGift:function(thc){
                    var crab=this;
                    var gift_id=crab.gift.name;
                    crab.gift.have=0;
                    var indexCrab=timeHandler.getNewIndex(),indexCrabAnim=timeHandler.getNewIndex();
                    timeHandler.queueAdd(indexCrab,function(){
                        delete crab.gift.opacity_conf["in"];
                        crab.setState("in",function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        crab.gift.opacity_conf["out"]={"step_arr":[19,25],"mode":"show"};
                        crab.setState("out",function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        thc.playSoundLoop("crab_move");
                        crab.setMove([copyArray(settings.conf_bag[0])],0,-1,1,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        thc.stopSoundLoop("crab_move");
                        _mySound.playSound("crab_in");
                        crab.setMove(copyArray(settings.conf_bag),0,-1,1,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        var arr=copyArray(settings.conf_bag);
                        arr.reverse();
                        arr.shift();
                        th.trigger("qface","happy");
                        _mySound.playSound("girl_smile");
                        crab.gift.name="";
                        crab.setMove(arr,0,-1,1,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        var pos=copyArray(crab.pos);
                        pos[1]+=400;
                        pos[0]+=mt_rand(-50,50);
                        thc.playSoundLoop("crab_move");
                        crab.setMove([pos],0,0,0,function(){
                            thc.stopSoundLoop("crab_move");
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueTrigger(indexCrab);
                    return gift_id;
            },
            draw:function(ctx){
                if(this.deleted){
                    return false;
                }
                var step_anim=this.anim_step;
                if(this.conf_all[this.state].loop){
                    step_anim=step_anim%this.conf_all[this.state].clips;
                }
                else{
                    step_anim=Math.min(step_anim,this.conf_all[this.state].clips-1);
                }
                var pos=zTransform(copyArray(this.pos),{width:this.conf.width,height:this.conf.height});
                var percent_size=pos[2];
                if(this.gift.marked || this.marked){
                    var key=this.selector.name;
                    if(this.gift.marked==2){
                        key="crab_down_red2";
                        if(this.step_all%10<5){
                            key="";
                        }
                    }
                    if(key!=""){
                        drawImageCropCenter(
                            ctx,imageAll[key],
                            pos[0]+this.selector.margin[0],pos[1]+this.selector.margin[1],
                            (this.step_all%this.selector.clips)*this.selector.width,0,
                            this.selector.width,this.selector.height,
                            percent_size
                        );
                    }
                }
                drawImageCropCenter(
                    ctx,imageAll[this.state],
                    pos[0],pos[1],
                    (step_anim)*this.conf.width,0,
                    this.conf.width,this.conf.height,
                    percent_size
                );
                if(this.gift.name && this.gift.opacity>0){
                    if(this.state=="move" || this.state=="wait"){
                        drawImageCropCenter(
                            ctx,imageAll[this.state+"_item_"+this.gift.name],
                            pos[0],pos[1],
                            (step_anim)*this.conf.width,0,
                            this.conf.width,this.conf.height,
                            percent_size,this.gift.opacity
                        );
                    }
                    else{
                        drawImageCropCenter(
                            ctx,imageAll["move_item_"+this.gift.name],
                            pos[0],pos[1],
                            0,0,
                            this.conf.width,this.conf.height,
                            percent_size,this.gift.opacity
                        );
                    }
                    
                }
                if(this.state=="move" || this.state=="wait"){
                    drawImageCropCenter(
                        ctx,imageAll[this.state+"_hand"],
                        pos[0],pos[1],
                        (step_anim)*this.conf.width,0,
                        this.conf.width,this.conf.height,
                        percent_size
                    );
                }
            }
        };
        
        function animObj(){
            this.conf_field=settings.conf_field;
            this.conf={
                step_on_move:15
            };
            this.fieldPos={};
            this.step=0;
            this.crab_arr={};
            this.table_lock=[];
            
            this.howmany=9;
            this.howmany_gift=2;
            this.next_move_count_arr=[4,5,6];
            this.next_move_count=4;//6
            
            this.rows;
            this.cols;
            this.function_on_step={};
            this.state="wait";
            this.live=-100;
            this.gift=0;
            this.gift_need=[];
            this.gift_have=[];
            this.live_max=-100;
            
            this.was_started=0;
            
            this.sound_loop={};
            
            this.level_conf={
                "0":{howmany:4,howmany_gift:1,next_move_add:0,lives:1},
                "1":{howmany:6,howmany_gift:1,next_move_add:0,lives:1},
                "2":{howmany:8,howmany_gift:1,next_move_add:0,lives:1},
                "3":{howmany:9,howmany_gift:1,next_move_add:0,lives:1},
                "4":{howmany:6,howmany_gift:2,next_move_add:0,lives:1},
                "5":{howmany:8,howmany_gift:2,next_move_add:0,lives:1},
                "6":{howmany:10,howmany_gift:2,next_move_add:0,lives:1},
                "7":{howmany:12,howmany_gift:2,next_move_add:0,lives:2},
                "8":{howmany:12,howmany_gift:2,next_move_add:1,lives:2},
                "9":{howmany:12,howmany_gift:2,next_move_add:2,lives:2}
            };
            
        }
        animObj.prototype={
            init:function(){
                this.playSoundLoop("beach_background");
                this.state="wait";
                this.setConf();
                this.preparePoints(this.howmany);
                this.initGifts();
                
                
                var i,crab_ava=[],pos_ava=[],crab_id,pos_id;
                for(i=1;i<=this.howmany;i++){
                    this.crab_arr[i]=new crabObj(
                        [-300,mt_rand(this.conf_field.top,this.conf_field.top+this.conf_field.height)]
                    );
                    this.crab_arr[i].init();
                    crab_ava.push(i);
                    pos_ava.push(i);
                }
                
                var crabGifted={};
                var ended=0;
                var ended_whistle=0;
                var thc=this;
                var nextMoveCount=this.next_move_count;
                var tmp;
                var was_scared=0;
                var howmany_real_have=0;
                for(i=0;i<this.howmany_gift;i++){
                    tmp=mt_rand(0,crab_ava.length-1);
                    crab_id=crab_ava[tmp];
                    crab_ava.splice(tmp,1);
                    tmp=mt_rand(0,pos_ava.length-1);
                    pos_id=pos_ava[tmp];
                    pos_ava.splice(tmp,1);
                    crabGifted[crab_id]={
                        obj:this.crab_arr[crab_id],
                        pos_obj:{pos:[copyArray(this.fieldPos[pos_id].pos)],pos_id:pos_id}
                    };
                }
//                this.playSoundLoop()
//                $.qLogClear();
                var giftStealCount=0,giftToSteal=copyArray(this.gift_need);
                function crabSteal(crab_id,wait){
                    var crab=crabGifted[crab_id].obj;
                    var pos_obj=crabGifted[crab_id].pos_obj;
                    var indexCrab=timeHandler.getNewIndex(),indexCrabAnim=timeHandler.getNewIndex();
                   timeHandler.queueAdd(indexCrab,function(){
                       //workaround, function start
                        crab.setMove([crab.pos],0,-1,1,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    
                    timeHandler.queueAdd(indexCrab,function(){
//                         crab.crab_speed=1300;
                        thc.playSoundLoop("crab_move");
                        howmany_real_have++;
                        crab.setMove([settings.conf_bag[0]],0,-1,1,function(){
                            thc.stopSoundLoop("crab_move");
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
//                        crab.crab_speed=4;
                        _mySound.playSound("crab_in");
                        crab.setMove(copyArray(settings.conf_bag),0,-1,1,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        timeHandler.setOne(indexCrabAnim,function(){
                            timeHandler.queueTrigger(indexCrab);
                        },100);
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        var arr=copyArray(settings.conf_bag);
                        arr.reverse();
                        arr.shift();
                        crab.giveGift(giftToSteal[giftStealCount]);
                        th.trigger("qface","scared");
                        giftStealCount++;
                        if(was_scared==0){
                            _mySound.playSound("girl_scared");
                        }
                        was_scared++;
                        thc.playSoundLoop("crab_move");
                        crab.setMove(arr,0,-1,1,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        crab.setMove(pos_obj.pos,0,pos_obj.pos_id,0,function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        thc.stopSoundLoop("crab_move");
                        crab.setState("in",function(){
                            timeHandler.queueTrigger(indexCrab);
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        crab.setState("out",function(){
                            crab.setState("wait");
                            crab.gift.marked=1;
                            ended++;
                            if(ended==howmany_real_have){
                                thc.howmany_gift=howmany_real_have;
                                thc.gift=howmany_real_have;
                                ended=0;
                                var crab_id;
                                function useCrab(crab){
                                    if(crab.haveGift()){
                                        crab.setState("whistle",function(){
                                            crab.setState("wait");
                                            if(ended_whistle==0){
                                                 timeHandler.queueTrigger(indexCrab);
                                            }
                                            ended_whistle++;
                                        });
                                    }
                                }
                                for(crab_id in thc.crab_arr){
                                    useCrab(thc.crab_arr[crab_id]);
                                }
                            }
                        });
                    });
                    timeHandler.queueAdd(indexCrab,function(){
                        var i,crab_id,pos_id;
                        var ready=0;
                        thc.playSoundLoop("crab_move");
                        for(i in crab_ava){
                            crab_id=crab_ava[i];
                            pos_id=pos_ava.shift();
                            thc.crab_arr[crab_id].setMove([copyArray(thc.fieldPos[pos_id].pos)],20,pos_id,0,function(){
                                ready++;
                                if(ready==thc.howmany-thc.howmany_gift){
                                    timeHandler.queueTrigger(indexCrab);
                                    thc.stopSoundLoop("crab_move");
                                }
                            });
                        }
                    });
                    //th
                    var counter_wait=1000,i;
                    for(i=3;i>=1;i--){
                        timeHandler.queueAdd(indexCrab,function(){
                            th.trigger("myCounter");
                            timeHandler.setOne(indexCrabAnim,function(){
                                timeHandler.queueTrigger(indexCrab);
                            },counter_wait);
                        });
                    }
                    timeHandler.queueAdd(indexCrab,function(){
                        thc.setNextMove(nextMoveCount);
                    });
                    
                    
                    timeHandler.setOne(indexCrabAnim,function(){
                        timeHandler.queueTrigger(indexCrab);
                    },wait);
                }
                
                //queueLength
                var wait=10;
                for(crab_id in crabGifted){
                    crabSteal(crab_id,wait);
                    wait+=550;
                }
                
            },
            initGifts:function(){
                //this.howmany_gift
                var gift_ava=[],gift_id,i,gift_id_max=intval(settings.crab_items),bum,len;
                for(i=1;i<=gift_id_max;i++){
                    gift_ava.push(i);
                }
                while(this.gift_need.length<this.howmany_gift){
                    len=gift_ava.length;
                    if(len>0){
                        i=mt_rand(0,len-1);
                        gift_id=gift_ava[i];
                        gift_ava.splice(i,1);
                    }
                    else{
                        gift_id=mt_rand(1,gift_id_max);
                    }
                    this.gift_need.push(gift_id);
                }
                
            },
            playSoundLoop:function(name){
                if(typeof this.sound_loop[name]!="undefined"){
                    return false;
                }
                this.sound_loop[name]=_mySound.playSound(name);
                return true;
            },
            stopSoundLoop:function(name){
                if(typeof this.sound_loop[name]=="undefined"){
                    return false;
                }
                _mySound.stopSound(this.sound_loop[name]);
                delete this.sound_loop[name];
                return true;
            },
            clear:function(){
                var i;
                for(i in this.sound_loop){
                    _mySound.stopSound(this.sound_loop[i]);
                }
            },
            setConf:function(){
                var qconf=this.level_conf[settings.level];
                this.howmany=qconf.howmany;
                this.howmany_gift=qconf.howmany_gift;
                this.gift=this.howmany_gift;
                var hard_level=0;
                if(settings.hard==2){
                    hard_level=1;
                }
                else if(settings.hard>2){
                    hard_level=2;
                }
                this.next_move_count=this.next_move_count_arr[hard_level];
                this.next_move_count+=qconf.next_move_add;
                this.live=qconf.lives;
                this.live_max=this.live;
            },
            takeGameState:function(){
                if(this.live==-100){
                    this.setConf();
                }
                
                return {
                    live:this.live,live_max:this.live_max,
                    gift_max:this.howmany_gift,gift:this.gift,
                    gift_have:copyArray(this.gift_have),gift_need:copyArray(this.gift_need)
                };
            },
            distanceCount:function(pos1,pos2){
                var distance=Math.max(
                    Math.abs(this.fieldPos[pos1].row-this.fieldPos[pos2].row),
                    Math.abs(this.fieldPos[pos1].col-this.fieldPos[pos2].col)
                );
                return distance;
            },
            setNextMove:function(rounds){
                var place_rounds={},crab_rounds={},crab_route={};
                var i,bum;
                for(i=1;i<=this.howmany;i++){
                    place_rounds[i]=0;
                    crab_rounds[i]={round:0,pos_id:this.crab_arr[i].pos_id};
                    crab_route[i]=[];
                    this.crab_arr[i].gift.marked=0;
                }
                var round,place_free,crab_id,crab,qkey,pos_id;
                for(round=1;round<=rounds;round++){
                    
                    for(crab_id=1;crab_id<=this.howmany;crab_id++){
                        crab=crab_rounds[crab_id];
                        place_free=[];
                        for(i in place_rounds){
                            bum=place_rounds[i];
                            if(bum<round && i!=crab.pos_id){
                                place_free.push(i);
                            }
                        }
                        if(crab.round<round ){
                            if(place_free.length>0){
                                qkey=mt_rand(0,place_free.length-1);
                                pos_id=place_free[qkey];

                                var distance=this.distanceCount(pos_id,crab.pos_id);
                                place_rounds[pos_id]=round+distance-1;
                                crab_rounds[crab_id].round+=distance;
                                crab_rounds[crab_id].pos_id=pos_id;
                                crab_route[crab_id].push({distance:distance,pos_id:pos_id});
                            }
                            else{
                                pos_id=crab.pos_id;
                                var distance=1;
                                place_rounds[pos_id]=round+distance-1;
                                crab_rounds[crab_id].round+=distance;
                                crab_rounds[crab_id].pos_id=pos_id;
                                crab_route[crab_id].push({distance:distance,pos_id:pos_id});
                            }
                        }
                        
                    }
                }
                var arr,pos,distance;
                var crabReady=0,crabHowmany=this.howmany,thc=this;
                this.playSoundLoop("crab_move");
                for(crab_id in crab_route){
                    arr=[];
                    distance=0;
                    for(i in crab_route[crab_id]){
                        bum=crab_route[crab_id][i];
                        pos_id=bum.pos_id;
                        distance+=bum.distance;
                        pos=copyArray(this.fieldPos[pos_id].pos);
                        arr.push(pos);
                    }
                    this.crab_arr[crab_id].setMove(arr,this.conf.step_on_move*distance,pos_id,0,function(){
                        crabReady++;
                        if(crabReady==crabHowmany){
                            thc.stopSoundLoop("crab_move");
                            thc.state="game";
                            th.trigger("crabReady");
                        }
                    });
                }
                
            },
            preparePoints:function(howmany){
                this.fieldPos={};
                var in_row=Math.ceil(Math.sqrt(howmany)),
                rows=Math.ceil(howmany/in_row);
                this.rows=rows;
                this.cols=in_row;
                var i,row,col,
                part_x=Math.round(this.conf_field.width/(in_row+1)),
                part_y=Math.round(this.conf_field.height/(rows+1));
                
                for(i=1;i<=howmany;i++){
                    row=Math.ceil(i/in_row);
                    col=i%in_row;
                    if(col==0){
                        col=in_row;
                    }
                    this.fieldPos[i]={pos:[col*part_x,row*part_y],row:row,col:col,str:row+"_"+col};
                }
            },
            start:function(){
                this.was_started=1;
                
            },
            draw:function(ctx){
                
                var i,arr_queue=[],tmp;
                for(i in this.crab_arr){
                    tmp=this.crab_arr[i].move();
                    arr_queue.push([i,tmp.pos[1]]);
                }
                arr_queue.sort(function(a,b){
                   return a[1]-b[1]; 
                });
                this.step++;
//                 
                ctx.clearRect(0, 0, settings.width, settings.height);
                for(i in arr_queue){
                    this.crab_arr[arr_queue[i][0]].draw(ctx);
                }
                
                
                
            },
            stopView:function(ctx){
                this.draw(ctx);
            },
            markCrab:function(pos){
                var crab_id;
                pos=zTransformInvert(pos);
                for(crab_id=1;crab_id<=this.howmany;crab_id++){
                    if(this.crab_arr[crab_id].isHit(pos)){
                        this.crab_arr[crab_id].marked=1;
                    }
                    else{
                        this.crab_arr[crab_id].marked=0;
                    }
                }
            },
            clickCrab:function(pos){
                var res={fail:0,succ:0,crab_id:cor_id,win:0,lose:0};
                if(this.state!="game"){
                    return res;
                }
                var crab_id,cor_id=0;
                pos=zTransformInvert(pos);
                for(crab_id=1;crab_id<=this.howmany;crab_id++){
                    if(this.crab_arr[crab_id].isHit(pos)){
                       cor_id=crab_id;
                       break;
                    }
                }
                if(cor_id==0){
                    return res;
                }
                var crab=this.crab_arr[cor_id];
                if(crab.in_game==0){
                    return res;
                }
                crab.in_game=0;
                if(cor_id>0 && this.state=="game"){
                    if(crab.haveGift()){
                        res.succ=1;
                        var gift_id=crab.returnGift(this);
                        this.gift_have.push(gift_id);
                        this.gift--;
                        if(this.gift==0){
                            res.win=1;
                            this.state=="end";
                        }
                        
                    }
                    else{
                        res.fail=1;
                        this.live--;
                        if(this.live<=-1){
                            res.lose=1;
                            crab.in_game=1;
                            this.runCrabs();
                            this.state="end";
                            _mySound.playSound("girl_scared");
                        }
                        else{
                            pos=copyArray(crab.pos);
                            pos[1]+=mt_rand(-100,100);
                            pos[0]=-300;
                            this.playSoundLoop("crab_move");
                            var thc=this;
                            crab.setMove([copyArray(pos)],0,-1,0,function(){
                                thc.stopSoundLoop("crab_move");
                            });
                        }
                    }
                }
                return res;
            },
            getCrab:function(crab_id){
                return this.crab_arr[crab_id];
            },
            runCrabs:function(){
                this.state="end";
                var crab_id,crab,pos;
                var need_move=0,ended=0;
                var thc=this;
                var crab_all=this.crab_arr;
                var crab_show=[];
                this.playSoundLoop("crab_move");
                for(crab_id in crab_all){
                    crab=crab_all[crab_id];
                    if(crab.in_game){
                        if(crab.haveGift()){
                            crab.gift.marked=2;
                        }
                        else{
//                            crab.marked=0;
                        }
                        crab.in_game=0;
                        crab_show.push(crab_id);
                    }
                }
                timeHandler.addOne(function(){
                    for(crab_id in crab_all){
                        crab=crab_all[crab_id];
                        if(in_array(crab_id,crab_show)){
                            pos=copyArray(crab.pos);
                            pos[0]=-300;
                            need_move++;
                            crab.setMove([copyArray(pos)],0,-1,0,function(){
                                ended++;
                                if(ended==need_move){
                                    thc.stopSoundLoop("crab_move");
                                }
                            });
                        }
                    }
                },2000);
                
            }
        };
        
        
        if(!settings){
            if(typeof options!="object"){
                return false;
            }
            var imageAll={};
            settings=$.extend( {
                width:1280,//{path:"gfx/place/fight/animation/cherry/1/anim.png",}
                height:780,
                period:40,
                level:1,
                isMobile:0,
                hard:0,
                hard_max:15,
                crab_items:5,
                conf_field:{
                    left:100,
                    top:100,
                    width:600,
                    height:700
                },
                conf_bag:[
                    [100,100]
                ]
            }, options);
            
//            $(".place.summergame").append("<div style='border:1px solid blue;position:absolute;"+
//            "width:"+settings.conf_field.width+"px;height:"+settings.conf_field.width+"px;"+
//            "left:"+settings.conf_field.left+"px;top:"+settings.conf_field.top+"px'></div>");
            
            
            th.attr({width:settings.width,height:settings.height});
            
            function getNewAnimIndex(){
                var i=getNewObjectIndex(_animIndex,{});
                _animIndex[i]={handler:timeHandler.getNewIndex()};
                _animStorage[i]={"obj_anim":{},cur_anim:""};
                
                //
                return i;
            }
            function initAnim(animIndex){
                _animStorage[animIndex].obj_anim=new animObj();
                _animStorage[animIndex].obj_anim.init();
                
            }
            if(typeof timeHandler=="undefined" || typeof timeHandler.getNewIndex=="undefined"){
                return false;//was not init
            }
            animIndex=getNewAnimIndex();
           
            var animIndexArr=_animIndex[animIndex];
           
            settings.animIndex=animIndex;
            var ctx=th[0];
            ctx=ctx.getContext("2d");
     
            function preparePreloadArr(){
                var arr={};
                var i,img_arr=[ "in","out","wait","wait_hand",
                "move","move_hand","crab_down","whistle","crab_down_red2"];
                for(i=1;i<=settings.crab_items;i++){
                    img_arr.push("move_item_"+i);
                    img_arr.push("wait_item_"+i);
                }
                for(i in img_arr){
                    arr[img_arr[i]]=_IMG_SERV+"/gfx/place/summergame/crab/"+img_arr[i]+".png";
                }
                return arr;
            }
            
            
            $("<div/>").one("myload",function(){
                var img_tmp=preparePreloadArr(),i,name;
                for(name in img_tmp){
                    imageAll[name]=new Image();
                    imageAll[name].src=img_tmp[name];
                }
                initAnim(animIndex);
                
                _animStorage[animIndex].obj_anim.stopView(ctx);
                
                th.data("summerGame",settings);
                
                drawScene();
                
                th.trigger("was_loaded");
            }).myLoad(preparePreloadArr());
            
        }
        else{
            var arg =Array.prototype.slice.call(arguments,1);
            animIndex=settings.animIndex;
            if(methods[options]){
                return methods[options].apply(this,arg);
            }
            
        }
        
        return true;
        
    };
});